import React from 'react'
import { useSelector } from 'react-redux'
import { uxSensorModeKindSelector } from '@src/selectors/app'
import { useIsActiveDexcom } from '@src/utils/hooks'
import { User } from '@src/utils'
import { MobileAppFeature, UserExperienceSensorModeKind } from '@src/types'
import { DexcomSensorSettingsContainer } from './DexcomSensorSettings'
import { SensorSettingsContainer } from './SensorSettings'

export const SensorSettingsScreen = () => {
  const isActiveDexcom = useIsActiveDexcom()
  const uxSensorModeKind = useSelector(uxSensorModeKindSelector)
  const hasSteloApiAccess = User.hasFeature(MobileAppFeature.DexcomSteloApiIntegration)
  const hasDexcomG7ApiAccess = User.hasFeature(MobileAppFeature.DexcomG7ApiIntegration)
  const hasDexcomG6ApiAccess = User.hasFeature(MobileAppFeature.DexcomG6ApiIntegration)

  const shouldBlockSteloIntegration =
    uxSensorModeKind === UserExperienceSensorModeKind.DexcomStelo && !hasSteloApiAccess
  const shouldBlockDexcomG7Integration =
    (uxSensorModeKind === UserExperienceSensorModeKind.OwnSensorDexcomG7 ||
      uxSensorModeKind === UserExperienceSensorModeKind.ActivePrescriptionDexcomG7) &&
    !hasDexcomG7ApiAccess
  const shouldBlockDexcomG6Integration =
    uxSensorModeKind === UserExperienceSensorModeKind.OwnSensorDexcomG6 && !hasDexcomG6ApiAccess
  const shouldUseDexcomSettings =
    isActiveDexcom &&
    !shouldBlockSteloIntegration &&
    !shouldBlockDexcomG7Integration &&
    !shouldBlockDexcomG6Integration

  if (shouldUseDexcomSettings) {
    return <DexcomSensorSettingsContainer />
  }

  return <SensorSettingsContainer />
}
